import Vue from 'vue';
import VueRouter from 'vue-router';
import {TitlebarAction} from '../interfaces/titlebar-action-enum';
import app from './app.vue';
import locationSearch from './views/location-search.vue';
import locationsList from './views/locations-list.vue';
import locationTypeFilter from './views/location-type-filter.vue';
import locationDetails from './views/location-details.vue';

declare const window: any;

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            name: 'locations',
            path: '/Mobile/Locations',
            component: app
        },
        {
            name: 'search',
            path: 'Search',
            component: locationSearch,
            meta: {
                titlebarOptions: {
                    title: 'Locations',
                    left: {
                        button: TitlebarAction.back,
                        callback: 'window.location.href = "/Mobile"'
                    },
                }
            }
        },
        {
            name: 'list',
            path: 'List',
            component: locationsList,
            meta: {
                titlebarOptions: {
                    title: 'Locations',
                    left: {
                        button: TitlebarAction.back,
                        callback: 'this.$router.replace({name: "search"})'
                    },
                    right: {
                        button: TitlebarAction.custom,
                        text: 'Filters',
                        callback: 'this.$router.replace({name: "filters"})'
                    }
                }
            }
        },
        {
            name: 'filters',
            path: 'Filters',
            component: locationTypeFilter,
            meta: {
                titlebarOptions: {
                    title: 'Filters',
                    left: {
                        button: TitlebarAction.custom,
                        text: 'Close',
                        callback: 'this.$router.replace({name: "list"})'
                    },
                    right: {
                        text: 'Apply',
                        button: TitlebarAction.custom,
                        callback: 'this.$router.replace({name: "list"})'
                    }
                }
            }
        },
        {
            name: 'details',
            path: 'Details',
            component: locationDetails,
            meta: {
                titlebarOptions: {
                    title: 'Location Details',
                    left: {
                        button: TitlebarAction.custom,
                        text: 'Close',
                        callback: 'this.$router.replace({name: "list"})'
                    }
                }
            }
        }
    ]
});

window.$router = router;

export default router;